import type { ReactNode } from "react"
import * as React from "react"
import {
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
  useRouteLoaderData,
} from "react-router"
import type { Route } from "./+types/root"

import { Footer } from "@/components/footer"
import { Header } from "@/components/header"
import { I18nProvider, type Locale } from "./lib/i18n"

import "@/index.css"
import { getDefaultMetaDescriptors } from "./components/seo"
import { getCookieValue } from "./lib/utils"

export function loader({ request }: Route.LoaderArgs): { lang: Locale } {
  const cookieLang = getCookieValue(request, "lang") as Locale | null
  const lang = cookieLang ?? import.meta.env.VITE_DEFAULT_LOCALE
  return { lang }
}

export function meta({
  data,
}: {
  data: { lang: Locale }
}): Route.MetaDescriptors {
  return [{ title: "Poremat" }, ...getDefaultMetaDescriptors(data.lang)]
}

export function Layout({
  children,
}: {
  children: ReactNode
}): React.JSX.Element {
  const { lang } = useRouteLoaderData("root") as { lang: Locale }
  return (
    <html lang={lang}>
      <head>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <link rel="icon" href="/favicon.ico" sizes="any" />
        <link rel="icon" href="/favicon.svg" type="image/svg+xml" />
        <Meta />
        <Links />
      </head>
      <body>
        {children}
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  )
}

export default function Root({
  loaderData,
}: Route.ComponentProps): React.JSX.Element {
  return (
    <I18nProvider initialLang={loaderData.lang}>
      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="grow">
          <Outlet />
        </main>
        <Footer />
      </div>
    </I18nProvider>
  )
}
